import {
  NAME_PART_MAX,
  PERSON_NAME_DISALLOWED,
} from "../../../utils/nameRules";

// "Create new contact" from the top search (QA batch 8): the typed text is put
// into the new client's name boxes. Individuals: first word = first name, last
// word = last name, words in between = middle name (each cut to what the boxes
// allow: letters, digits, apostrophes, hyphens and periods, max 20). Organizations: the text is the company
// name (max 50). An email address goes into the email box instead.

const COMPANY_MAX = 50;

const namePart = (word: string) =>
  word.replace(PERSON_NAME_DISALLOWED, "").slice(0, NAME_PART_MAX);

const looksLikeEmail = (text: string) => /^\S+@\S+\.\S+$/.test(text);

export type IndividualPrefill = {
  firstName?: string;
  middleName?: string;
  lastName?: string;
  displayName?: string;
  email?: string;
};

export type OrganizationPrefill = {
  companyName?: string;
  primaryContactEmail?: string;
};

export const individualPrefill = (typed?: string | null): IndividualPrefill => {
  const text = (typed || "").trim();
  if (!text) return {};
  if (looksLikeEmail(text)) return { email: text };
  const words = text
    .split(/\s+/)
    .map(namePart)
    .filter((w) => /[\p{L}\p{N}]/u.test(w));
  if (!words.length) return {};
  const firstName = words[0];
  const lastName = words.length > 1 ? words[words.length - 1] : "";
  const middleName =
    words.length > 2 ? namePart(words.slice(1, -1).join(" ")) : "";
  const displayName = [firstName, middleName, lastName]
    .filter(Boolean)
    .join(" ");
  return { firstName, middleName, lastName, displayName };
};

export const organizationPrefill = (
  typed?: string | null,
): OrganizationPrefill => {
  const text = (typed || "").trim().replace(/\s+/g, " ");
  if (!text) return {};
  if (looksLikeEmail(text)) return { primaryContactEmail: text };
  return { companyName: text.slice(0, COMPANY_MAX).trim() };
};
